export const MAXIMUM_PROJECTS_THRESHOLD = '5';
